import React, { useEffect, useCallback } from 'react';
import { Card } from '@patternfly/react-core';
import { useLingui } from '@lingui/react/macro';
import { useLocation } from 'react-router';
import useRequest from 'hooks/useRequest';
import { LabelsAPI } from 'api';
import { getQSConfig, parseQueryString } from 'util/qs';
import PaginatedTable, { HeaderRow, HeaderCell } from '../PaginatedTable';
import LabelListItem from './LabelListItem';

const qsConfig = getQSConfig(
  'labels',
  {
    page: 1,
    page_size: 20,
    order_by: 'name',
  },
  []
);

function LabelLists() {
  const { t } = useLingui();
  const location = useLocation();

  const {
    result: { results, count },
    error: contentError,
    isLoading,
    request: fetchLabels,
  } = useRequest(
    useCallback(async () => {
      const params = {
        ...parseQueryString(qsConfig, location.search),
        unifiedjobtemplate_labels__search: '',
      };
      const { data } = await LabelsAPI.read(params);
      return {
        results: data.results,
        count: data.count,
      };
    }, [location.search]),
    { results: [], count: 0 }
  );

  useEffect(() => {
    fetchLabels();
  }, [fetchLabels]);

  return (
    <Card>
      <PaginatedTable
        contentError={contentError}
        hasContentLoading={isLoading}
        items={results}
        itemCount={count}
        pluralizedItemName={t`Labels`}
        qsConfig={qsConfig}
        toolbarSearchColumns={[
          { name: t`Name`, key: 'name__icontains', isDefault: true },
          {
            name: t`Organization`,
            key: 'organization__name__icontains',
          },
        ]}
        headerRow={
          <HeaderRow qsConfig={qsConfig}>
            <HeaderCell sortKey="name">{t`Name`}</HeaderCell>
            <HeaderCell>{t`Organization`}</HeaderCell>
          </HeaderRow>
        }
        renderRow={(label) => (
          <LabelListItem key={label.id} label={label} searchOrg />
        )}
      />
    </Card>
  );
}

export default LabelLists;
